/* eslint-disable no-console */
import {Flex} from 'antd';
import React from 'react';

import BoxContent from '../../../components/BoxContent/BoxContent';
import MainTableTitle from '../../../components/Table/Utils/MainTableTitle';
import {formatIndian} from '../../../utils/formatIndian';
import {convertGjToTjValueUnitObject} from '../../../utils/formatValueWithUnit';
import {filterMainAndSubData} from '../constants/commonFunctions';
import ChartLabelComponent from '../generalized/utils/ChartLabelComponent';
import {chartType, IChartLabelType} from '../interface/IChart';

import ChartSwitch from './ChartSwitch';

const TotalChartList: React.FC<{
  data: any[];
  keyArray: string[];
  chartType?: chartType;
  dataInMainData?: boolean;
  showTitle?: boolean;
  showTotal?: boolean;
  showChartList?: boolean;
  noBackground?: boolean;
  tooltip?: string;
  labelType?: IChartLabelType;
  isLabelValue?: boolean;
  customTotalTitle?: string;
  isCost?: boolean;
  convertToTJ?: boolean;
  isBlock?: boolean;
}> = ({
  data,
  keyArray,
  chartType = 'donut',
  showTitle = true,
  showTotal = true,
  noBackground = false,
  tooltip = '',
  dataInMainData = false,
  showChartList = true,
  labelType,
  isLabelValue = false,
  customTotalTitle = '',
  isCost = false,
  convertToTJ = false,
  isBlock = false
}) => {
  const {mainData, subData} = filterMainAndSubData(data, 'dataId', keyArray);

  const mainTitle = mainData?.label?.split(' ') ?? [''];
  const lastWord = mainTitle[mainTitle?.length - 1];

  return (
    <BoxContent noBackground={noBackground}>
      <Flex className="ghgEmissionByScope">
        {showTitle && (
          <Flex className="titleFlex">
            <MainTableTitle
              title={mainData?.label}
              showDivider={false}
              tooltip={tooltip}
              isBlock={isBlock}
            />
          </Flex>
        )}
        <Flex
          className="contentChartLabel"
          style={{
            marginTop: showChartList ? 'unset' : '1rem'
          }}
        >
          {showChartList && (
            <ChartLabelComponent
              data={subData}
              total={
                convertToTJ
                  ? convertGjToTjValueUnitObject(
                      mainData?.value ?? 0,
                      mainData?.unit ?? ''
                    )
                  : {
                      unit: mainData?.unit ?? '',
                      value: formatIndian(mainData?.value ?? 0)
                    }
              }
              showTotal={showTotal}
              type={labelType}
              mainTitle={mainTitle.length === 2 ? lastWord : undefined}
              isValue={isLabelValue}
              customTotalTitle={customTotalTitle}
              convertToTJ={convertToTJ}
            />
          )}
          <ChartSwitch
            data={
              dataInMainData
                ? {mainData, subData: subData ?? []}
                : {mainData, subData}
            }
            chartType={chartType}
            isCost={isCost}
            convertToTJ={convertToTJ}
          />
        </Flex>
      </Flex>
    </BoxContent>
  );
};

export default TotalChartList;
